import React from 'react';
import ReactDOM from 'react-dom/client';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import './assets/scss/main.scss';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import PageStart from './Start/PageStart';
import PageLogin from './Login/PageLogin';

const router = createBrowserRouter([
    {
        path: '/',
        element: <PageStart />
    },
    {
        path: '/login',
        element: <PageLogin />
    }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);

serviceWorkerRegistration.register({
    onUpdate: (registration) => {
        if (registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            window.location.reload();
        }
    }
});
